import React, { useState } from "react";
import {
  Box,
  Checkbox,
  FormControl,
  TextField,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Table,
} from "@mui/material";

const CohortUserSelect = (props) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredUsers =
    props.seedData.users?.filter(
      (user) =>
        user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.id.toString().includes(searchTerm) ||
        user.mobile.includes(searchTerm)
    ) || [];

  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const selectedUsers = props.cohortSelectUser || [];

  const handleCheckboxChange = (e, id) => {
    const updated = e.target.checked
      ? [...selectedUsers, id]
      : selectedUsers.filter((uid) => uid !== id);
    props.handleCohortSelectUserChange(updated);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.wrapper}>
        <FormControl fullWidth>
          <Box component="p" sx={styles.label}>
            Select User <span style={styles.required}>*</span>
          </Box>

          <TextField
            fullWidth
            variant="standard"
            label="Search by ID/Name/Phone No."
            value={searchTerm}
            onChange={handleSearchChange}
            sx={styles.textField}
          />

          <Box sx={styles.tableScrollWrapper}>
            <Box sx={styles.tableInnerWrapper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Select</TableCell>
                    <TableCell>ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Phone</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredUsers.map((user) => (
                    <TableRow key={user.id}>
                      <TableCell>
                        <Checkbox
                          checked={selectedUsers.includes(user.id)}
                          onChange={(e) => handleCheckboxChange(e, user.id)}
                        />
                      </TableCell>
                      <TableCell>{user.id}</TableCell>
                      <TableCell>{user.name || "N/A"}</TableCell>
                      <TableCell>{user.mobile}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Box>

          {props.errors?.cohortSelectUser && (
            <Box component="p" sx={styles.error}>
              {props.errors.cohortSelectUser}
            </Box>
          )}
        </FormControl>
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    minHeight: { xs: "auto", md: "100vh" },
    padding: { xs: "20px 10px", sm: "20px", md: "40px 20px" },
    borderRadius: "24px",
    width: "100%",
    boxSizing: "border-box",
  },
  wrapper: {
    width: "100%",
    maxWidth: "1200px",
    padding: { xs: "10px", sm: "20px" },
  },
  label: {
    fontSize: { xs: "18px", sm: "20px", md: "24px" },
    fontWeight: 500,
    marginBottom: "10px",
    textAlign: { xs: "center", sm: "left" },
  },
  required: {
    color: "red",
  },
  textField: {
    "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
    "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
    marginBottom: "15px",
  },
  tableScrollWrapper: {
    width: "100%",
    maxHeight: "400px",
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
  },
  tableInnerWrapper: {
    minWidth: "100%", // Ensure it uses full width
  },
  error: {
    color: "red",
    fontSize: { xs: "12px", sm: "14px" },
    marginTop: "10px",
    textAlign: "center",
  },
  "@media (max-width: 768px)": {
    tableScrollWrapper: {
      maxWidth: "100%",
      overflowX: "scroll", // Make sure it scrolls horizontally if needed
    },
    tableInnerWrapper: {
      minWidth: "600px", // Reduce table width to fit smaller screens
    },
    label: {
      fontSize: "16px", // Smaller label for mobile
    },
  },
};

export default CohortUserSelect;
